import moment from "moment";
import React from "react";

const RecentActivities = ({ recentActivities }) => {
  return (
    <div className="bg-white shadow-md rounded-lg sm:pb-10 md:pb-10  ">
      <h2 className="p-4 text-lg font-semibold">Recent Activities</h2>
      <ul className="h-56 overflow-y-auto hide-scrollbar">
        {recentActivities?.length > 0 ? (
          recentActivities.map((activity, index) => (
            <li
              key={index}
              className="px-5 flex items-center justify-between pb-4 mb-4 border-b last:border-none last:pb-0 last:mb-0"
            >
              <div className="flex items-center">
                <div>
                  <p className="font-semibold">{activity.name}</p>
                  <p className="text-sm text-gray-500">{activity.activity}</p>
                </div>
              </div>
              <p className="text-sm text-gray-500">
                {moment(activity.createdAt).format("DD MMM YYYY")}
              </p>
            </li>
          ))
        ) : (
          <tr className="">
            <td colSpan="7" className=" px-5 text-center  text-gray-500 py-4">
              No recent activities found.
            </td>
          </tr>
        )}
      </ul>
    </div>
  );
};

export default RecentActivities;
